function roundRectPath(ctx, x, y, w, h, r) {
  const tl = r?.topLeft ?? r ?? 0;
  const tr = r?.topRight ?? r ?? 0;
  const br = r?.bottomRight ?? 0;
  const bl = r?.bottomLeft ?? 0;
  ctx.beginPath();
  ctx.moveTo(x + tl, y);
  ctx.lineTo(x + w - tr, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + tr);
  ctx.lineTo(x + w, y + h - br);
  ctx.quadraticCurveTo(x + w, y + h, x + w - br, y + h);
  ctx.lineTo(x + bl, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - bl);
  ctx.lineTo(x, y + tl);
  ctx.quadraticCurveTo(x, y, x + tl, y);
  ctx.closePath();
}

// Plugin that adds a gradient overlay to bars
export const BarShineOverlay = {
  id: 'BarShineOverlay',
  afterDatasetsDraw(chart, _args, opts) {
    const { ctx } = chart;
    const {
      isDummy = [],
      borderRadius = { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 },
      colorTop = 'rgba(255,255,255,0.2)',
      colorBottom = 'rgba(0,0,0,0.05)',
    } = opts || {};

    chart.data.datasets.forEach((ds, di) => {
      const meta = chart.getDatasetMeta(di);
      meta.data.forEach((el, i) => {
        if (!el || ds.data[i] == null || isDummy[i]) return;

        // current geometry (no “final” props so hover doesn’t stick)
        const { x, y, base, width } = el.getProps(['x', 'y', 'base', 'width'], false);
        const top = Math.min(y, base);
        const bottom = Math.max(y, base);
        const left = x - width / 2;
        const w = width;
        const h = Math.max(1, bottom - top);

        ctx.save();
        // clip to the same rounded shape as the bar
        roundRectPath(ctx, left, top, w, h, borderRadius);
        ctx.clip();

        // vertical gradient overlay
        const g = ctx.createLinearGradient(0, top, 0, bottom);
        g.addColorStop(0, colorTop);
        g.addColorStop(1, colorBottom);

        ctx.fillStyle = g;
        ctx.fillRect(left, top, w, h);
        ctx.restore();
      });
    });
  },
};
